import { schemes, zSchema } from "@zeal/common";

export const postPaystubRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  start_date: zSchema.string(),
  end_date: zSchema.string(),
  media_type: zSchema.string(),
});

export type TPostPaystubRequestSchema = zSchema.infer<
  typeof postPaystubRequestSchema
>;
